



























































































import { Component, Prop, Vue, Watch } from 'vue-property-decorator'
import moment from 'moment'
import APIClient from '@/API/APIClient'
import SearchConverter from '@/components/party/search/SearchConverter'
import SubSearchTrackDisplayer from '@/components/party/search/SubSearchTrackDisplayer.vue'
import TrackResponse from '@/types/TrackResponse'
import SongRequest from '@/types/SongRequest'
import { namespace } from 'vuex-class'
import vuescroll, { Config } from 'vuescroll'
import SubSearchArtistDisplayer from '@/components/party/search/SubSearchArtistDisplayer.vue'
import SubSearchPlaylistDisplayer from '@/components/party/search/SubSearchPlaylistDisplayer.vue'
import AddedToQueuePopup from '@/components/miniComponents/AddedToQueuePopup.vue'
import SeeAllButton from '@/components/party/search/SeeAllButton.vue'
import SubBrowseCategoryDisplayer from '@/components/party/search/SubBrowseCategoryDisplayer.vue'
import ArtistResponse from '@/types/ArtistResponse'
import PlaylistResponse from '@/types/PlaylistResponse'
import CategoryResponse from '@/types/CategoryResponse'

const userModule = namespace('user')
const partyRoomModule = namespace('partyRoom')

enum SearchTypes {
  TRACK,
  ARTIST,
  PLAYLIST,
  CATEGORY
}

interface NextSearch {
  type: SearchTypes;
  url: string;
}

enum Mode {
  SEARCH = 'search',
  BROWSE = 'browse'
}

@Component({
  components: { SubBrowseCategoryDisplayer, SeeAllButton, AddedToQueuePopup, SubSearchPlaylistDisplayer, SubSearchArtistDisplayer, SubSearchTrackDisplayer, vuescroll }
})
export default class SubSearch extends Vue {
  name = 'SubSearch'

  @Prop() query!: string

  ops: Config = {
    scrollPanel: {
      scrollingX: false,
      easing: 'easeInOutQuad'
    },
    rail: {
      opacity: 1,
      size: '0px'
    },
    bar: {
      disable: true
    }
  }

  @userModule.Getter('userID') userID!: string
  @userModule.Getter('displayName') displayName!: string
  @partyRoomModule.Getter('partyID') partyID!: string

  private mode = Mode.BROWSE
  private loading = false
  private showPopup = false

  private timeOut = 0

  private popupTimer = 0
  private popupTimeout = 0

  lastEdit = 0

  currentLevel = 0

  items = new Array<Array<ArtistResponse | TrackResponse | PlaylistResponse | CategoryResponse>>()

  nextSearch = new Array<NextSearch>()

  searchingNext = false

  @Watch('query')
  onQueryChanged (val: string) {
    this.lastEdit = moment().valueOf()
    clearTimeout(this.timeOut)
    this.loading = true
    this.timeOut = setTimeout(() => {
      this.loading = false
      if (this.lastEdit >= moment().subtract(1.5, 'seconds').valueOf()) {
        if (val.length > 0 && val === this.query) {
          this.mode = Mode.SEARCH
          this.search(val)
        } else if (val.length === 0) {
          this.currentLevel = 0
          this.items = []
          this.mode = Mode.BROWSE
          this.getTopCategories()
        }
      }
    }, 1000)
  }

  @Watch('currentLevel')
  onCurrentLevelChanged (val: number) {
    if (val === 0 && this.query === '') {
      this.mode = Mode.BROWSE
    }
    (this.$refs.vs1 as vuescroll).scrollTo({ x: 0, y: 0 })
  }

  mounted () {
    this.getTopCategories()
  }

  created () {
    const vs = this.$refs.vs1 as vuescroll
  }

  // eslint-disable-next-line @typescript-eslint/ban-ts-ignore
  // @ts-ignore
  handleScroll (vertical) {
    if (vertical.process > 0.90 && !this.searchingNext && (this.currentLevel === 0 ? this.query.length <= 0 : true)) this.searchNext()
    else if (vertical.process < 0.90) this.searchingNext = false
  }

  async getTopCategories () {
    const categoryResult = await APIClient.Spotify.getTopCategories()
    const categories = categoryResult.categories.items.map(SearchConverter.convertCategorySearchToCategory)
    Vue.set(this.items, 0, categories)
    Vue.set(this.nextSearch, 0, { type: SearchTypes.CATEGORY, url: categoryResult.categories.next })
  }

  async getCategorysPlaylists (categoryID: string) {
    const playlistResult = await APIClient.Spotify.getCategorysPlaylist(categoryID)
    console.log(playlistResult)
    this.mode = Mode.SEARCH
    const playlists = playlistResult.playlists.items.map(SearchConverter.convertPlaylistSearchToPlaylist)
    this.currentLevel++
    Vue.set(this.items, this.currentLevel, playlists)
    Vue.set(this.nextSearch, this.currentLevel, { type: SearchTypes.PLAYLIST, url: playlistResult.playlists.next })
  }

  async searchArtist (artistID: string) {
    const trackResult = await APIClient.Spotify.getArtistTracks(artistID)
    const tracks = trackResult.tracks.map(SearchConverter.convertTrackSearchToTrack)
    this.currentLevel++
    Vue.set(this.items, this.currentLevel, tracks)
    Vue.set(this.nextSearch, this.currentLevel, { type: SearchTypes.TRACK, url: trackResult.tracks.next })
  }

  async searchPlaylist (playlistID: string) {
    const trackResult = await APIClient.Spotify.getPlaylist(playlistID)
    const tracks = trackResult.tracks.items.map((track: SpotifyApi.PlaylistTrackObject) => SearchConverter.convertTrackSearchToTrack(track.track))
    this.currentLevel++
    Vue.set(this.items, this.currentLevel, tracks)
    Vue.set(this.nextSearch, this.currentLevel, { type: SearchTypes.TRACK, url: trackResult.tracks.next })
  }

  async searchAllTracks () {
    const trackResult = await APIClient.Spotify.searchAllTracks(this.query)
    const tracks = trackResult.tracks.items.map(SearchConverter.convertTrackSearchToTrack)
    this.currentLevel++
    Vue.set(this.items, this.currentLevel, tracks)
    Vue.set(this.nextSearch, this.currentLevel, { type: SearchTypes.TRACK, url: trackResult.tracks.next })
  }

  async searchAllArtists () {
    const artistResult = await APIClient.Spotify.searchAllArtists(this.query)
    const tracks = artistResult.artists.items.map(SearchConverter.convertArtistSearchToArtist)
    this.currentLevel++
    Vue.set(this.items, this.currentLevel, tracks)
    Vue.set(this.nextSearch, this.currentLevel, { type: SearchTypes.ARTIST, url: artistResult.artists.next })
  }

  async searchAllPlaylists () {
    const playlistResult = await APIClient.Spotify.searchAllPlaylists(this.query)
    const tracks = playlistResult.playlists.items.map(SearchConverter.convertPlaylistSearchToPlaylist)
    this.currentLevel++
    Vue.set(this.items, this.currentLevel, tracks)
    Vue.set(this.nextSearch, this.currentLevel, { type: SearchTypes.PLAYLIST, url: playlistResult.playlists.next })
  }

  async searchNext () {
    this.searchingNext = true
    const nextSearch = this.nextSearch[this.currentLevel]
    const result = await APIClient.Spotify.searchNext(nextSearch.url)
    if (nextSearch.type === SearchTypes.TRACK) {
      const tracks = result.tracks.items.map(SearchConverter.convertTrackSearchToTrack)
      this.items[this.currentLevel].push(...tracks)
      Vue.set(this.nextSearch, this.currentLevel, { type: SearchTypes.TRACK, url: result.tracks.next })
    } else if (nextSearch.type === SearchTypes.ARTIST) {
      const tracks = result.artists.items.map(SearchConverter.convertArtistSearchToArtist)
      this.items[this.currentLevel].push(...tracks)
      Vue.set(this.nextSearch, this.currentLevel, { type: SearchTypes.TRACK, url: result.artists.next })
    } else if (nextSearch.type === SearchTypes.PLAYLIST) {
      const tracks = result.playlists.items.map(SearchConverter.convertPlaylistSearchToPlaylist)
      this.items[this.currentLevel].push(...tracks)
      Vue.set(this.nextSearch, this.currentLevel, { type: SearchTypes.TRACK, url: result.playlists.next })
    } else if (nextSearch.type === SearchTypes.CATEGORY) {
      const categories = result.categories.items.map(SearchConverter.convertCategorySearchToCategory)
      this.items[this.currentLevel].push(...categories)
      Vue.set(this.nextSearch, this.currentLevel, { type: SearchTypes.CATEGORY, url: result.categories.next })
    }
  }

  async search (query: string) {
    this.currentLevel = 0
    const res = []
    const result = await APIClient.Spotify.generalSearch(query)
    console.log(result)
    const tracks = result.tracks.items.length > 0 ? result.tracks.items.map(SearchConverter.convertTrackSearchToTrack).sort((a: any, b: any) => b.popularity - a.popularity) : []
    const artists = result.artists.items.length > 0 ? result.artists.items.map(SearchConverter.convertArtistSearchToArtist).sort((a: any, b: any) => b.popularity - a.popularity) : []
    const playlists = result.playlists.items.length > 0 ? result.playlists.items.map(SearchConverter.convertPlaylistSearchToPlaylist).sort((a: any, b: any) => b.popularity - a.popularity) : []
    if (tracks.length > 0) res.push(tracks[0])
    if (artists.length > 0) res.push(artists[0])
    if (playlists.length > 0) res.push(playlists[0])
    if (tracks.length > 0) {
      tracks.shift()
      res.push(...tracks)
    }
    if (artists.length > 0) {
      artists.shift()
      res.push(...artists)
    }
    if (playlists.length > 0) {
      playlists.shift()
      res.push(...playlists)
    }
    Vue.set(this.items, 0, res)
  }

  async addTrack (track: TrackResponse) {
    clearInterval(this.popupTimer)
    this.showPopup = false
    const songRequest: SongRequest = {
      addedBy: this.userID,
      upVotes: 0,
      imageUrl: track.imageUrl,
      displayName: this.displayName,
      artist: SearchConverter.convertArtistNamesToString(track.artistNames),
      title: track.name,
      requested: moment().valueOf(),
      spotifyUri: track.spotifyUri,
      spotifyID: track.id,
      played: false
    }
    try {
      this.showPopup = true
      this.popupTimer = setTimeout(() => {
        this.showPopup = false
      }, 1000)
      await APIClient.PartyRoom.addSongRequest(this.partyID, songRequest)
    } catch (e) {
      console.log(e)
    }
  }
}
